export const TELEGRAMM_MAX_LENGTH = 20;
